module.exports = __webpack_public_path__ + "p8_img3.jpg?745f07f0e6879e4cc5841533a7d7f474";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p8/p8_img3.jpg
// module id = 184
// module chunks = 0